import BaseComponent from "../components/BaseComponent";
import {Panel, SplitCol, SplitLayout, View} from "@vkontakte/vkui";
import IncomingDocs from "../incoming/IncomingDocs";
import IncomingStep1 from "../incoming/Step1";
import IncomingStep2 from "../incoming/Step2";
import IncomingStep3 from "../incoming/Step3";
import IncomingStep4 from "../incoming/Step4";
import DefectiveAct from "../incoming/DefectiveAct";
import DocQntInput from "../incoming/DocQntInput";
import TakeAPhoto from "../components/TakeAPhoto";
import React from "react";
import * as constants from "../assets/constants";
import {AdaptivityContext} from "../assets/constants";
import BaseApi from "../api/BaseApi";

class FragmentIncoming extends BaseComponent {
    constructor(props) {
        super(props)

        let current_docs_incoming = localStorage.getItem(constants.current_docs_incomings_key)

        if (current_docs_incoming) {
            try {
                current_docs_incoming = JSON.parse(current_docs_incoming)
            } catch (e) {
                current_docs_incoming = null
            }

        } else {
            current_docs_incoming = null
        }
        const state = {
            activePanelIncoming: 'incomingdocs_panel',
            IncomingImageEventName: "setIncomingImage",
            current_incoming_ids: current_docs_incoming?.current_incoming_ids ?? [],
            currentIncomingDocs: current_docs_incoming?.currentIncomingDocs ?? {},
            currentDefectiveProduct: null,
            currentDefectiveProductIndex: null,

            currentQntProduct: null,
            currentQntProductIndex: null,

        }

        this.state = {
            ...this.state,
            ...state
        }
    }

    receiveMessage = (event) => {


        if (event.data.type !== undefined && event.data.type === 'saveDefectiveAct') {
            const {qnt, comment, doc, series} = event.data
            this.saveDefectiveAct(qnt, comment, doc, series)
            this.setState({activePanelIncoming: 'incoming_step3_panel'})
        }
        if (event.data.type !== undefined && event.data.type === 'saveIncomingQnt') {
            const {qnt, series} = event.data
            this.saveIncomingQnt(qnt, series)
            this.setState({activePanelIncoming: 'incoming_step3_panel'})
        }
        if (event.data.type !== undefined && event.data.type === 'addDefectiveAct') {

            this.lastState = undefined
            this.setState({
                activePanelIncoming: 'incoming_defective_act_panel',
                currentDefectiveProduct: event.data.product,
                currentDefectiveProductIndex: event.data.index
            })
        }

        if (event.data.type == "setIncomingImage" || event.data.type == "setDefectiveImage") {

            const keyName = event.data.type == "setIncomingImage" ? constants.photo_incomings_key : constants.photo_defective_act_key

            let old = {}

            const data = localStorage.getItem(keyName)
            let items = {}
            let itemsOld = {}

            if (data && data !== "undefined") {
                itemsOld = JSON.parse(data)
                if (event.data.type == "setIncomingImage") {
                    items = itemsOld
                }
                if (event.data.type == "setDefectiveImage") {
                    items = itemsOld[this.state.currentDefectiveProduct.GUID] ?? {}
                }
            }


            if (items[this.state.numIncomingImage] == undefined) {
                items[this.state.numIncomingImage] = {}
            } else {
                old = items[this.state.numIncomingImage]
            }
            old.hasImage = true
            old.mainImage = event.data.data.image
            old.thumb = event.data.data.thumb
            old.datetime = new Date()

            items[this.state.numIncomingImage] = old

            if (event.data.type == "setIncomingImage") {
                itemsOld = items
            }
            if (event.data.type == "setDefectiveImage") {
                itemsOld[this.state.currentDefectiveProduct.GUID] = items
            }

            localStorage.setItem(keyName, JSON.stringify(itemsOld))

            setTimeout(() =>
                window.postMessage({type: 'reloadIncomingImages'}), 600)

            return
        }
        if (event.data.type !== undefined && event.data.type === 'addQntInput') {

            this.setState({
                activePanelIncoming: 'incoming_qnt_input_panel',
                currentQntProduct: event.data.product,
                currentQntProductIndex: event.data.index
            })
        }
        if (event.data.type !== undefined && event.data.type === 'setStep') {

            let newData = {}

            const lowerName = event.data.objectName.toLowerCase()
            newData[`activePanel${event.data.objectName}`] = `${event.data.objectName.toLowerCase()}_step${event.data.numStep}_panel`

            this.setState(newData)
            return
        }
        if (event.data.type !== undefined && event.data.type === 'endIncoming') {
            this.setState({activePanelIncoming: 'incomingdocs_panel',})
            window.postMessage('goToMain')
            this.openLoadingNoty("Документ успешно выгружен", 2000, true)
            setTimeout(() => this.clearIncomingData(constants.CODE_INCOMING_STATUS_SENT), 1000)
        }
        if (event.data.type !== undefined && event.data.type === 'clearIncoming') {
            this.clearIncomingData()
            this.openLoadingNoty("Данные приемки очищены, выберите документы для создания новой", 3000, true)
        }
        if (event.data.type !== undefined && event.data.type === 'startIncoming') {

            this.clearIncomingData()
            const docsData = {current_incoming_ids: event.data.ids, currentIncomingDocs: event.data.incomingDocs}

            localStorage.setItem(constants.current_docs_incomings_key, JSON.stringify(docsData))
            if (this.state.current_incoming_ids) {
                BaseApi.post('/?app=incomings&act=setStatus', {
                    ids: this.state.current_incoming_ids,
                    status: constants.CODE_INCOMING_STATUS_NEW
                })
            }
            BaseApi.post('/?app=incomings&act=setStatus', {
                ids: JSON.stringify(event.data.ids),
                status: constants.CODE_INCOMING_STATUS_IN_PROCESS
            })
            this.setState({
                activePanelIncoming: 'incoming_step1_panel',
                current_incoming_ids: event.data.ids,
                currentIncomingDocs: event.data.incomingDocs
            })
            return
        }
    }
    clearIncomingData = (status = constants.CODE_INCOMING_STATUS_NEW) => {
        localStorage.setItem(constants.values_incomings_key, "")
        localStorage.setItem(constants.photo_incomings_key, "")
        localStorage.setItem(constants.monitoring_items_key, "")
        localStorage.setItem(constants.data_defective_act_key, "")
        localStorage.setItem(constants.current_docs_incomings_key, "")
        if (this.state.current_incoming_ids) {
            BaseApi.post('/?app=incomings&act=setStatus', {
                ids: JSON.stringify(this.state.current_incoming_ids),
                status
            })
        }
        this.setState({

            current_incoming_ids: [],
            currentIncomingDocs: {}
        })
    }

    saveDefectiveAct = (qnt, comment, doc, series) => {
        const data = localStorage.getItem(constants.data_defective_act_key)
        let allItems = {}
        if (data && data !== "undefined") {
            allItems = JSON.parse(data)
        }
        const newItem = {qnt, comment, doc, series}
        allItems[this.state.currentDefectiveProduct.GUID] = newItem

        localStorage.setItem(constants.data_defective_act_key, JSON.stringify(allItems))
    }


    saveIncomingQnt = (qnt, series) => {
        const data = localStorage.getItem(constants.values_incomings_key)
        let allItems = {}
        if (data && data !== "undefined") {
            allItems = JSON.parse(data)
        }
        const newItem = {qnt, series}
        allItems[this.state.currentQntProduct.GUID] = newItem

        localStorage.setItem(constants.values_incomings_key, JSON.stringify(allItems))
    }

    render() {
        return <View activePanel={this.state.activePanelIncoming} >
            <Panel id="incomingdocs_panel">
                <SplitLayout>
                    {AdaptivityContext.isMobile ? '' : this.MainMenu()}
                    <SplitCol width={"25%"}>
                        <IncomingDocs
                            base_url={this.state.base_url}
                            current_user={this.props.current_user}
                            current_docs_ids={this.state.current_incoming_ids}
                            current_docs={this.state.currentIncomingDocs}
                        />
                    </SplitCol>
                </SplitLayout>
            </Panel>
            <Panel id="incoming_step1_panel">
                <IncomingStep1 base_url={this.state.base_url}
                               current_user={this.props.current_user}
                               ids={this.state.current_incoming_ids}
                               currentDocs={this.state.currentIncomingDocs}
                />
            </Panel>
            <Panel id="incoming_step2_panel">
                <IncomingStep2 base_url={this.state.base_url}
                               current_user={this.props.current_user}
                               father={this}
                               currentDocs={this.state.currentIncomingDocs}
                />
            </Panel>
            <Panel id="incoming_step3_panel">
                <IncomingStep3 base_url={this.state.base_url}
                               current_user={this.props.current_user}
                               father={this}
                               ids={this.state.current_incoming_ids}
                               currentDocs={this.state.currentIncomingDocs}
                />
            </Panel>

            <Panel id="incoming_step4_panel">
                <IncomingStep4 base_url={this.state.base_url}
                               current_user={this.props.current_user}
                               father={this}
                               ids={this.state.current_incoming_ids}
                               currentDocs={this.state.currentIncomingDocs}
                />
            </Panel>

            <Panel id="incoming_defective_act_panel">
                <DefectiveAct base_url={this.state.base_url}
                              current_user={this.props.current_user}
                              father={this}
                              product={this.state.currentDefectiveProduct}
                              product_index={this.state.currentDefectiveProductIndex}
                              current_docs={this.state.currentIncomingDocs}
                />
            </Panel>

            <Panel id="incoming_qnt_input_panel">
                <DocQntInput base_url={this.state.base_url}
                             current_user={this.props.current_user}
                             father={this}
                             product={this.state.currentQntProduct}
                             product_index={this.state.currentQntProductIndex}
                             current_docs={this.state.currentIncomingDocs}
                />
            </Panel>
            <Panel id="incoming_photo_panel">
                <SplitLayout>
                    <SplitCol width={"50%"}>
                        <TakeAPhoto eventName={this.state.IncomingImageEventName}
                                    hidePhotos={() => this.setState({activePanelIncoming: this.state.lastIncomingPanel})}
                                    url={this.state.url}
                                    openErrorNoty={this.openErrorNoty}/>
                    </SplitCol>
                </SplitLayout>
            </Panel>
        </View>
    }

}

export default FragmentIncoming